import { zodResolver } from "@hookform/resolvers/zod";
import { useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { object, string } from "zod";

const userConnectionSchema = object({
  value: string().trim(),
});

export type UserConnectionFormValues = { value: string };

/**
 * Owns the single-field form behind the inline connection-id editor. `value` is
 * the raw text; `getSubmittedValue` normalises it to the API shape, where an
 * empty string means "clear the connection id" (`null`).
 */
export const useUserConnectionForm = (value: string | null) => {
  const resolver = useMemo(() => zodResolver(userConnectionSchema), []);

  const form = useForm<UserConnectionFormValues>({
    resolver,
    defaultValues: { value: value ?? "" },
  });

  const reset = useCallback(() => form.reset({ value: value ?? "" }), [form, value]);

  return {
    control: form.control,
    handleSubmit: form.handleSubmit,
    reset,
    getSubmittedValue: (values: UserConnectionFormValues) => values.value || null,
  };
};
